<div class="flex items-center">
  <div *ngIf="imgSrc" class="rounded w-12 h-12 lg:w-16 lg:h-16 mr-3">
    <img [src]="imgSrc" class="w-full h-full object-contain" />
  </div>
  <div class="align-baseline">
    <span class="body-big text-grey-dark align-baseline">{{ formattedAmount }} {{ currency }}</span>
    <span class="ml-2 self-end body-mention text-grey-dark60" *ngIf="end">{{ end }}</span>
  </div>
</div>
